/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationPublicRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type AgentTeam = 'SALES' | 'MARKETING' | 'SERVICE' | unhandledEnumCase;

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */
export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */
export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type DefaultTierPointsCreditedTierOption =
  | 'diamond'
  | 'elite'
  | 'gold'
  | 'none'
  | 'platinum'
  | unhandledEnumCase;

export type DefaultTypeOption =
  | 'directory_user'
  | 'partner'
  | 'provider'
  | unhandledEnumCase;

export type CategoryV2 =
  | 'ACCOUNT_BASED_MARKETING'
  | 'ACCOUNTING'
  | 'ADVERTISING'
  | 'APPLICANT_TRACKING_SYSTEMS'
  | 'CALLING'
  | 'COLLABORATION'
  | 'COMPETITIVE_INTELLIGENCE'
  | 'CONNECTOR'
  | 'CONSENT_MANAGEMENT'
  | 'CONTENT_MANAGEMENT_SYSTEM'
  | 'CONVERSATION_INTELLIGENCE'
  | 'CPQ'
  | 'CRM'
  | 'CUSTOMER_SUCCESS'
  | 'DATA_MIGRATION'
  | 'DATA_QUALITY_BACKUP'
  | 'DIGITAL_PLATFORM_ADOPTION'
  | 'DIRECT_MAIL_AUTOMATION'
  | 'E_COMMERCE'
  | 'E_SIGNATURE'
  | 'EMAIL'
  | 'ERP'
  | 'ETL'
  | 'EVENT_MANAGEMENT'
  | 'EXPERIENCE_MANAGEMENT'
  | 'FIELD_SERVICE'
  | 'FORM_BUILDER'
  | 'FUNDRAISING_NON_PROFIT'
  | 'HELP_DESK'
  | 'IPAAS'
  | 'KNOWLEDGE_BASE'
  | 'LEAD_SCORING_ROUTING'
  | 'LEARNING_MANAGEMENT_SYSTEM'
  | 'LIVE_CHAT'
  | 'MARKETING_ANALYTICS'
  | 'MARKETING_AUTOMATION'
  | 'MESSAGING_NETWORK'
  | 'PARTNER_MANAGEMENT'
  | 'PAYMENTS'
  | 'PRODUCT_ANALYTICS'
  | 'PROJECT_MANAGEMENT'
  | 'PROPOSALS'
  | 'SALES_ANALYTICS'
  | 'SALES_COMPENSATION'
  | 'SALES_ENABLEMENT'
  | 'SALES_ENGAGEMENT'
  | 'SALES_INTELLIGENCE'
  | 'SCHEDULING'
  | 'SENSITIVE_DATA'
  | 'SEO'
  | 'SESSION_REPLAYS'
  | 'SMS'
  | 'SOCIAL_MEDIA_MANAGEMENT'
  | 'SOCIAL_NETWORKS'
  | 'SPREADSHEETS'
  | 'SUBSCRIPTION_MANAGEMENT'
  | 'SURVEYS'
  | 'TICKETING'
  | 'VIDEO'
  | 'WEBINARS'
  | 'WORKFLOW_AUTOMATION'
  | 'WORKFORCE_MANAGEMENT'
  | unhandledEnumCase;

export type PlanType =
  | 'FREE'
  | 'MONTHLY'
  | 'YEARLY'
  | 'ONE_TIME'
  | 'METERED'
  | 'CONTACT_US'
  | unhandledEnumCase;

export type OfferingType = 'APP' | 'THEME' | 'MODULE' | unhandledEnumCase;

export type Tier =
  | 'MARKETING_STARTER'
  | 'MARKETING_PROFESSIONAL'
  | 'MARKETING_ENTERPRISE'
  | 'SALES_STARTER'
  | 'SALES_PROFESSIONAL'
  | 'SALES_ENTERPRISE'
  | 'SERVICE_STARTER'
  | 'SERVICE_PROFESSIONAL'
  | 'SERVICE_ENTERPRISE'
  | 'CMS_STANDALONE'
  | 'HUBSPOT_FREE'
  | 'CMS_ENTERPRISE'
  | 'OPS_ENTERPRISE'
  | 'OPS_PROFESSIONAL'
  | 'OPS_STARTER'
  | 'CMS_STARTER'
  | 'CONTENT_STARTER'
  | 'CONTENT_PROFESSIONAL'
  | 'CONTENT_ENTERPRISE'
  | unhandledEnumCase;

export type Highlight = {
  source: Default<HighlightSource>;
  highlightText: string;
  /** @deprecated */
  sectionType: SuggestionSectionType;
};

export type HighlightSource = {
  type: HighlightSourceType;
  suggestionSectionType?: SuggestionSectionType;
};

export type HighlightSourceType = 'SUGGESTION_SECTION' | unhandledEnumCase;

export type ListingCard = {
  listingId: number;
  listingName: string;
  /** @deprecated */
  providerName?: string;
  companyName?: string;
  description?: string;
  iconUrl?: string;
  listingTrellisIcon?: string;
  slug: string;
  installCount?: number;
  betaStage?: BetaStage;
  displayTag?: ProductDisplayTag;
  displayTagLabel?: string;
  products: Default<ProductCard[]>;
  recommendationSources: Default<RecommendationSource[]>;
  highlights: Default<Highlight[]>;
  /** @deprecated Placeholder for profile search. Not indexed yet. */
  reviewSummary?: ReviewSummaryCard;
};

export type ProductCard = {
  productId?: number;
  sourceId?: string;
  productType?: ProductType;
  agentType?: AgentType;
  agentTeam?: AgentTeam;
  hasUbb?: boolean;
  connectionType?: ConnectionType;
  certified?: boolean;
  builtByHubSpot?: boolean;
  installed?: boolean;
  portalInstallable?: boolean;
  workflowActions: Default<WorkflowActionCard[]>;
  builtInWorkflowActionTypes: Default<string[]>;
  workflowObjectives?: string[];
  productFeatures: Default<ProductFeatureCard[]>;
  partnerTier?: DefaultTierPointsCreditedTierOption;
  partnerType?: DefaultTypeOption;
  worksWithBreeze: boolean;
};

export type AutocompleteCard = {
  resultType: AutocompleteResultType;
  term: string;
  sourceTerm: string;
  language: string;
  listing?: ListingAutocompleteResult;
  query?: QueryAutocompleteResult;
  category?: CategoryAutocompleteResult;
  collection?: CollectionAutocompleteResult;
  catalogService?: CatalogServiceAutocompleteResult;
  productTypes: Default<ProductType[]>;
};

export type AutocompleteRequest = {
  queryTerm: string;
  language: string;
  fallbackLanguage: Default<string>;
  limit: Default<number>;
  useSpellingCorrections: Default<boolean>;
  resultTypes: Default<AutocompleteResultType[]>;
  productTypes: Default<ProductType[]>;
  rankerId?: string;
};

export type AutocompleteResponse = { results: Default<AutocompleteCard[]> };

export type CatalogServiceAutocompleteResult = { catalogServiceId: number };

export type CategoryAutocompleteResult = {
  categories: Default<CategoryV2[]>;
  slug?: string;
};

export type CollectionAutocompleteResult = {
  collectionId: number;
  slug: string;
};

export type ListingAutocompleteResult = { card: ListingCard };

export type QueryAutocompleteResult = { queryType: QueryType };

export type RecommendationSource = {
  sourceName: string;
  version: Default<number>;
};

export type SearchRequest = {
  queryType?: QueryType;
  search?: string;
  language: string;
  collectionId?: number;
  filter?: Filter;
  sorts: Default<Sort[]>;
  offset?: number;
  length?: number;
  suggestionSectionFilter?: SuggestionSectionFilter;
  rankerId?: string;
};

export type SearchResponse = {
  total: number;
  cards: Default<ListingCard[]>;
  aiAnswer?: string;
  aiRequestId?: string;
  queryType?: QueryType;
  contextId?: string;
};

export type SuggestionSectionFilter = {
  sectionTypes: Default<SuggestionSectionType[]>;
  contexts: Default<SuggestionSectionContext[]>;
  minimumSectionCardCount: Default<number>;
};

export type AiCallbackRequest = { requestId: string };

export type AiStreamingResponse = {
  delta?: string;
  completeAnswer?: string;
  status: Default<Status>;
  requestId: string;
};

export type Status = 'IN_PROGRESS' | 'SUCCESS' | 'FAILURE' | unhandledEnumCase;

export type SuggestionSection = {
  cards: Default<ListingCard[]>;
  sectionType: SuggestionSectionType;
  title: string;
  contexts: Default<SuggestionSectionContext[]>;
};

export type SuggestionSectionContext = {
  contextType: SuggestionSectionContextType;
  value: string;
};

export type SuggestionSectionContextType =
  | 'USE_CASE'
  | 'PRODUCT_ID'
  | 'LISTING_ID'
  | unhandledEnumCase;

export type SuggestionSectionType =
  | 'MOST_INSTALLED'
  | 'NEWEST'
  | 'TRENDING'
  | 'VIEW_BASED_TRENDING'
  | 'USAGE_BASED_TRENDING'
  | 'VIEW_AND_INSTALLS'
  | 'TECH_STACK'
  | 'INSTALLED_WITH'
  | 'SIMILAR_PORTALS'
  | 'USE_CASE'
  | 'COMPLEMENTARY'
  | 'TOOL_USAGE'
  | 'REQUIRED_APPS_INSTALLED'
  | unhandledEnumCase;

export type SuggestionSectionsByTypeRequest = {
  sectionTypes: Default<SuggestionSectionType[]>;
  language: Default<string>;
  minimumSectionCardCount: Default<number>;
  maximumSectionCardCount: Default<number>;
  contexts: Default<SuggestionSectionContext[]>;
  productTypes: Default<ProductType[]>;
};

export type SuggestionSectionsRequest = {
  maximumSections: number;
  language: string;
  minimumSectionCardCount: number;
  maximumSectionCardCount: number;
  contexts: Default<SuggestionSectionContext[]>;
  productTypes: Default<ProductType[]>;
};

export type SuggestionSectionsResponse = {
  sections: Default<SuggestionSection[]>;
  contextId?: string;
};

export type ProductDisplayTag =
  | 'APP'
  | 'AGENT'
  | 'ASSISTANT'
  | 'CONNECTOR'
  | 'SOLUTIONS_PARTNER'
  | 'WORKFLOW_TEMPLATE'
  | 'FEATURED_AGENT'
  | 'AGENT_TEMPLATE'
  | unhandledEnumCase;

export type ProductType =
  | 'APP'
  | 'THEME'
  | 'MODULE'
  | 'AGENT'
  | 'SOLUTIONS_PARTNER_PROFILE'
  | 'WORKFLOW_TEMPLATE'
  | unhandledEnumCase;

export type AgentType =
  | 'STUDIO'
  | 'ASSISTANT'
  | 'OFF_PLATFORM'
  | unhandledEnumCase;

export type ConnectionType =
  | 'STANDARD'
  | 'HOMEMADE_IFRAME'
  | 'HOMEMADE_EXTERNAL'
  | 'HOMEMADE_MODAL'
  | 'HOMEMADE_PREINSTALLED'
  | 'HOMEMADE_UNIFIED_ACCOUNT'
  | unhandledEnumCase;

export type BetaStage =
  | 'PRIVATE_BETA'
  | 'PUBLIC_BETA'
  | 'PRE_RELEASE'
  | unhandledEnumCase;

/**
 *  Response card model for marketplace assets (themes and modules).
 *  Represents a single asset in search results returned via CHIRP RPC.
 */
export type AssetCard = {
  offeringId: number;
  offeringType: OfferingType;
  slug: string;
  name: string;
  companyName: string;
  priceCents: number;
  installsCount: number;
  thumbnailUrl?: string;
  exampleUrl?: string;
  firstPublishedAt?: number;
  featureHeadlines: Default<string[]>;
  score?: number;
  reviewCount: number;
  averageRating: number;
  overallAdjustedRating?: number;
};

/**
 *  Request model for searching marketplace assets (themes and modules) via CHIRP RPC.
 *  Extends AssetQueryFields which provides all the filter and query parameters.
 */
export type AssetSearchRequest = {
  language: string;
  search?: string;
  nameSearch?: string;
  offeringIds?: number[];
  offeringTypes?: AssetOfferingTypeFilter;
  tiers?: TierFilter;
  absentScopes?: string[];
  businessTypes?: AssetBusinessTypeFilter;
  pageTypes?: AssetPageTypeFilter;
  pageFeatures?: AssetPageFeatureFilter;
  contentTypes?: ModuleContentTypeFilter;
  categories?: ModuleCategoryFilter;
  tags?: AssetTagFilter;
  providers?: AssetProviderFilter;
  planType?: PlanType;
  priceRange?: PriceRangeFilter;
  minOverallRating?: number;
  minReviewCount?: number;
  hasFreeSupport?: boolean;
  sorts: Default<AssetSortField[]>;
  slug?: string;
  length: Default<number>;
  offset: Default<number>;
  portalCompatible: Default<boolean>;
  searchSource: Default<SearchSource>;
  debug: Default<boolean>;
};

/**
 *  Response model for asset search via CHIRP RPC.
 *  Contains the total count and list of asset cards matching the search criteria.
 */
export type AssetSearchResponse = {
  total: number;
  cards: Default<AssetCard[]>;
};

export type AssetSortField =
  | 'INSTALL_COUNT_DESC'
  | 'REVIEW_COUNT_DESC'
  | 'RATING_OVERALL_DESC'
  | 'RATING_EASE_OF_USE_DESC'
  | 'RATING_SUPPORT_DESC'
  | 'RATING_VALUE_DESC'
  | 'RATING_PERFORMANCE_DESC'
  | 'NEWEST'
  | 'PRICE_DESC'
  | 'PRICE_ASC'
  | 'RANKING_ASC'
  | 'RELEVANCE_DESC'
  | unhandledEnumCase;

export type BaseQueryField =
  | 'LISTING_ID'
  | 'ORDERED_LISTING_ID'
  | 'PRODUCT_ID'
  | 'PRODUCT_TYPE'
  | 'OVERALL_RATING'
  | 'ADJUSTED_OVERALL_RATING'
  | 'REVIEW_COUNT'
  | 'INSTALL_COUNT'
  | 'FIRST_PUBLISHED_AT'
  | 'LISTING_LANGUAGE'
  | 'TIER'
  | 'WORKS_WITH_BREEZE'
  | 'WORKFLOW_ACTIONS'
  | 'WORKFLOW_ACTION_NAME'
  | 'WORKFLOW_ACTION_COMPATIBLE_OBJECT_TYPE_IDS'
  | 'WORKFLOW_ACTION_OBJECT_TYPE_IDS'
  | 'WORKFLOW_ACTION_IS_TOOL'
  | 'WORKFLOW_ACTION_SUPPORTED_CLIENT_APPS'
  | 'WORKFLOW_ACTION_SUPPORTED_CLIENTS'
  | 'PRODUCT_FEATURE_TYPE'
  | 'PRODUCT_FEATURE_NAME'
  | 'PRODUCT_FEATURE_METADATA'
  | 'BUILT_BY_HUBSPOT'
  | 'SOURCE_ID'
  | 'USE_CASES'
  | 'DISPLAY_TAG'
  | 'LISTING_NAME'
  | 'LISTING_SLUG'
  | 'CERTIFIED'
  | 'APP_PARTNER_TIER'
  | 'TECHNOLOGY_PARTNER_TIER'
  | 'CONNECTION_TYPE'
  | 'IS_BREEZE_CONNECTOR'
  | 'SYNC_DIRECTION'
  | 'CATEGORY'
  | 'PRICING_PLAN'
  | 'HUBSPOT_FEATURES'
  | 'SUPPORT_LANGUAGES'
  | 'APP_LANGUAGES'
  | 'TOOL_INTEGRATIONS'
  | 'AGENT_TYPE'
  | 'AGENT_TEAM'
  | 'HAS_UBB'
  | 'PROFILE_SOLUTIONS_PARTNER_TIER'
  | 'PROFILE_BUDGET'
  | 'PROFILE_CATALOG_SERVICES'
  | 'PROFILE_INDUSTRIES'
  | 'PROFILE_LANGUAGES'
  | 'PROFILE_ACCREDITATIONS'
  | 'PROFILE_CERTIFICATIONS'
  | 'PROFILE_SUPPORTED_LISTINGS'
  | 'PROFILE_LOCATION_COUNTRY'
  | 'PROFILE_OFFICE_LOCATION'
  | 'PROFILE_PORTAL_ID'
  | 'OBJECTIVE'
  | 'HUB_PLAN'
  | 'REQUIRED_APP_IDS'
  | 'REQUIRED_AGENT_IDS'
  | 'INSTALLED'
  | 'PORTAL_INSTALLABLE'
  | 'REQUIRED_APPS_INSTALLED'
  | unhandledEnumCase;

export type FeatureType =
  | 'UIE'
  | 'MCP_SERVER'
  | 'WORKFLOW_ACTION'
  | 'WORKFLOW_TRIGGER'
  | unhandledEnumCase;

export type ProductFeatureCard = {
  type?: FeatureType;
  name?: string;
  description?: string;
  metadata: Default<Record<string, string>>;
};

export type ReviewSummaryCard = {
  overallRating: number;
  reviewCount: number;
  overallAdjustedRating?: number;
};

export type SearchSource = 'STANDARD' | 'SEARCH_BAR' | unhandledEnumCase;

export type Sort = { field: BaseQueryField; order: SortOrder };

export type SortOrder = 'ASC' | 'DESC' | unhandledEnumCase;

export type WorkflowActionCard = {
  name?: string;
  actionTypeId?: string;
  isTool?: boolean;
  supportedClients: Default<string[]>;
  objectTypeIds: Default<string[]>;
  orderIndex?: string;
  iconType?: string;
  iconUrl?: string;
  iconActionType?: string;
};

/**
 *  RPC-compatible filter for theme business types.
 */
export type AssetBusinessTypeFilter = {
  clause: QueryClause;
  values: Default<AssetBusinessType[]>;
};

/**
 *  RPC-compatible filter for asset offering types (THEME or MODULE).
 */
export type AssetOfferingTypeFilter = {
  clause: QueryClause;
  values: Default<OfferingType[]>;
};

/**
 *  RPC-compatible filter for theme page features.
 */
export type AssetPageFeatureFilter = {
  clause: QueryClause;
  values: Default<AssetPageFeature[]>;
};

/**
 *  RPC-compatible filter for theme page types.
 */
export type AssetPageTypeFilter = {
  clause: QueryClause;
  values: Default<AssetPageType[]>;
};

/**
 *  RPC-compatible filter for asset providers (company names).
 */
export type AssetProviderFilter = {
  clause: QueryClause;
  values: Default<string[]>;
};

/**
 *  RPC-compatible filter for asset tags.
 */
export type AssetTagFilter = { clause: QueryClause; values: Default<string[]> };

export const BooleanFilterQueryTypename =
  'com.hubspot.marketplace.search.models.filters.BooleanFilterQuery';
export const BooleanFilterQueryDiscriminant = 'BooleanFilterQuery';
export const BooleanFilterQueryDiscriminantKey = '@type';
export type BooleanFilterQuery = {
  values: Default<boolean[]>;
  greaterThanOrEqualTo?: boolean;
  lessThanOrEqualTo?: boolean;
  negation: Default<boolean>;
  clause: Default<QueryClause>;
  __typename: 'com.hubspot.marketplace.search.models.filters.BooleanFilterQuery';
} & { '@type'?: 'BooleanFilterQuery' };

export const ExistsFilterQueryTypename =
  'com.hubspot.marketplace.search.models.filters.ExistsFilterQuery';
export const ExistsFilterQueryDiscriminant = 'ExistsFilterQuery';
export const ExistsFilterQueryDiscriminantKey = '@type';
export type ExistsFilterQuery = {
  negation: Default<boolean>;
  clause: Default<QueryClause>;
  __typename: 'com.hubspot.marketplace.search.models.filters.ExistsFilterQuery';
} & { '@type'?: 'ExistsFilterQuery' };

export type Filter = {
  filterGroups: Default<FilterGroup[]>;
  clause: Default<QueryClause>;
  negation: Default<boolean>;
};

export type FilterGroup = {
  filtersByField: Default<Record<string, FilterQuery[]>>;
  clause: Default<QueryClause>;
  negation: Default<boolean>;
};

export const FilterQueryDiscriminantKey = '@type';
export type FilterQuery =
  | BooleanFilterQuery
  | ExistsFilterQuery
  | FloatFilterQuery
  | LongFilterQuery
  | StringFilterQuery;

export const FloatFilterQueryTypename =
  'com.hubspot.marketplace.search.models.filters.FloatFilterQuery';
export const FloatFilterQueryDiscriminant = 'FloatFilterQuery';
export const FloatFilterQueryDiscriminantKey = '@type';
export type FloatFilterQuery = {
  values: Default<number[]>;
  greaterThanOrEqualTo?: number;
  lessThanOrEqualTo?: number;
  negation: Default<boolean>;
  clause: Default<QueryClause>;
  __typename: 'com.hubspot.marketplace.search.models.filters.FloatFilterQuery';
} & { '@type'?: 'FloatFilterQuery' };

export const LongFilterQueryTypename =
  'com.hubspot.marketplace.search.models.filters.LongFilterQuery';
export const LongFilterQueryDiscriminant = 'LongFilterQuery';
export const LongFilterQueryDiscriminantKey = '@type';
export type LongFilterQuery = {
  values: Default<number[]>;
  greaterThanOrEqualTo?: number;
  lessThanOrEqualTo?: number;
  negation: Default<boolean>;
  clause: Default<QueryClause>;
  __typename: 'com.hubspot.marketplace.search.models.filters.LongFilterQuery';
} & { '@type'?: 'LongFilterQuery' };

/**
 *  RPC-compatible filter for module categories.
 *  Uses String values (category names) matching the core implementation.
 */
export type ModuleCategoryFilter = {
  clause: QueryClause;
  values: Default<string[]>;
};

/**
 *  RPC-compatible filter for module content types.
 *  Uses String values (content type names) matching the core implementation.
 */
export type ModuleContentTypeFilter = {
  clause: QueryClause;
  values: Default<string[]>;
};

/**
 *  RPC-compatible filter for asset price range.
 */
export type PriceRangeFilter = { minCents: number; maxCents: number };

export type QueryClause = 'AND' | 'OR' | unhandledEnumCase;

export const StringFilterQueryTypename =
  'com.hubspot.marketplace.search.models.filters.StringFilterQuery';
export const StringFilterQueryDiscriminant = 'StringFilterQuery';
export const StringFilterQueryDiscriminantKey = '@type';
export type StringFilterQuery = {
  values: Default<string[]>;
  greaterThanOrEqualTo?: string;
  lessThanOrEqualTo?: string;
  negation: Default<boolean>;
  clause: Default<QueryClause>;
  __typename: 'com.hubspot.marketplace.search.models.filters.StringFilterQuery';
} & { '@type'?: 'StringFilterQuery' };

/**
 *  RPC-compatible filter for asset tiers. Only supports OR queries.
 */
export type TierFilter = { clause: QueryClause; values: Default<Tier[]> };

export type AssetBusinessType =
  | 'ART_ENTERTAINMENT'
  | 'TECHNOLOGY'
  | 'REAL_ESTATE'
  | 'PROFESSIONAL_SERVICES'
  | 'ECOMMERCE'
  | 'NONPROFIT_EDUCATION'
  | 'FINANCIAL_SERVICES'
  | 'FOOD_BEVERAGE'
  | 'HEALTH_BEAUTY'
  | 'MARKETING'
  | 'EVENT_MANAGEMENT'
  | 'TRAVEL_HOSPITALITY'
  | 'HR_RECRUITING'
  | 'CUSTOMER_SERVICE'
  | 'RETAIL'
  | 'SMALL_BUSINESS'
  | unhandledEnumCase;

export type AssetPageFeature =
  | 'ACCORDION'
  | 'APP_INTEGRATION'
  | 'BANNER'
  | 'BLOG_POST_LISTING'
  | 'CALENDAR'
  | 'CARD'
  | 'CAROUSEL'
  | 'COUNTDOWN'
  | 'CTA'
  | 'EVENT'
  | 'FEATURED_CONTENT'
  | 'FILTER'
  | 'FOOTER'
  | 'FORM'
  | 'GALLERY'
  | 'HEADER'
  | 'HERO'
  | 'IMAGE'
  | 'LOGO'
  | 'MAP'
  | 'MENU'
  | 'NEWS'
  | 'PAGINATION'
  | 'PARALLAX'
  | 'PRICING_TABLE'
  | 'PRODUCT_LIBRARY'
  | 'PROGRESS_BAR'
  | 'SEARCH'
  | 'SLIDER'
  | 'SOCIAL'
  | 'SUBMENU'
  | 'SUBSCRIBE'
  | 'TABLE'
  | 'TABS'
  | 'TEAM_MEMBER'
  | 'TESTIMONIAL'
  | 'VIDEO'
  | 'WEATHER'
  | unhandledEnumCase;

export type AssetPageType =
  | 'ABOUT'
  | 'BLOG_POST'
  | 'BLOG_POST_LISTING'
  | 'CASE_STUDY'
  | 'COMING_SOON'
  | 'CONFIRMATION'
  | 'CONTACT_US'
  | 'EBOOK'
  | 'ERROR'
  | 'EVENT'
  | 'FAQ'
  | 'HOMEPAGE'
  | 'LANDING'
  | 'LOGIN'
  | 'NEWSLETTER'
  | 'OFFER'
  | 'PILLAR'
  | 'PRICING'
  | 'PRODUCT_LIBRARY'
  | 'REGISTRATION'
  | 'RESOURCES'
  | 'SEARCH_RESULTS'
  | 'SERVICES'
  | 'SINGLE_PRODUCT'
  | 'SUBSCRIPTION'
  | 'TEAM_MEMBERS'
  | 'TESTIMONIALS'
  | 'UNDER_CONSTRUCTION'
  | 'WEBINAR'
  | unhandledEnumCase;

export type AutocompleteResultType =
  | 'QUERY'
  | 'LISTING'
  | 'CATEGORY'
  | 'COLLECTION'
  | 'CATALOG_SERVICE'
  | unhandledEnumCase;

export type QueryType = 'ELASTIC_SEARCH' | 'VAAS' | 'LLM' | unhandledEnumCase;

export type SearchRequestType = Requestify<SearchRequest>;
export type SearchResponseType = SearchResponse;
export type SearchErrorType = EmptyError & HubspotMetadata;
export const searchRpc: ChirpAvroRpcDetails<
  SearchRequestType,
  SearchResponseType,
  SearchErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.personalization.rpc.PersonalizationPublicRpc',
  rpcName: 'search',
  auth: 'external',
  fingerprint: 'PW_1y7W3L6_qjdDQOFDRspwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type AutocompleteRequestType = Requestify<AutocompleteRequest>;
export type AutocompleteResponseType = AutocompleteResponse;
export type AutocompleteErrorType = EmptyError & HubspotMetadata;
export const autocompleteRpc: ChirpAvroRpcDetails<
  AutocompleteRequestType,
  AutocompleteResponseType,
  AutocompleteErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.personalization.rpc.PersonalizationPublicRpc',
  rpcName: 'autocomplete',
  auth: 'external',
  fingerprint: 'e26zL9PrYyGy-hEMUEeA9ZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSuggestionSectionsRequestType =
  Requestify<SuggestionSectionsRequest>;
export type GetSuggestionSectionsResponseType = SuggestionSectionsResponse;
export type GetSuggestionSectionsErrorType = EmptyError & HubspotMetadata;
export const getSuggestionSectionsRpc: ChirpAvroRpcDetails<
  GetSuggestionSectionsRequestType,
  GetSuggestionSectionsResponseType,
  GetSuggestionSectionsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.personalization.rpc.PersonalizationPublicRpc',
  rpcName: 'getSuggestionSections',
  auth: 'external',
  fingerprint: 'ka5BedAKnPXU0Hesa7BvcZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSuggestionSectionsByTypeRequestType =
  Requestify<SuggestionSectionsByTypeRequest>;
export type GetSuggestionSectionsByTypeResponseType =
  SuggestionSectionsResponse;
export type GetSuggestionSectionsByTypeErrorType = EmptyError & HubspotMetadata;
export const getSuggestionSectionsByTypeRpc: ChirpAvroRpcDetails<
  GetSuggestionSectionsByTypeRequestType,
  GetSuggestionSectionsByTypeResponseType,
  GetSuggestionSectionsByTypeErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.personalization.rpc.PersonalizationPublicRpc',
  rpcName: 'getSuggestionSectionsByType',
  auth: 'external',
  fingerprint: 'BeJsjZMBPf7U0Hesa7BvcZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type StreamAiResponseRequestType = Requestify<AiCallbackRequest>;
export type StreamAiResponseResponseType = AiStreamingResponse;
export type StreamAiResponseErrorType = EmptyError & HubspotMetadata;
export const streamAiResponseRpc: ChirpAvroRpcDetails<
  StreamAiResponseRequestType,
  StreamAiResponseResponseType,
  StreamAiResponseErrorType,
  true
> = {
  serviceName:
    'com.hubspot.marketplace.personalization.rpc.PersonalizationPublicRpc',
  rpcName: 'streamAiResponse',
  auth: 'external',
  fingerprint: 'O8TNc1n_fZiFxj_-39CsnpwP6LXzGzX8',
  na1Only: false,
  isStreaming: true,
  isHublessAppAuth: false,
};

export type SearchAssetsRequestType = Requestify<AssetSearchRequest>;
export type SearchAssetsResponseType = AssetSearchResponse;
export type SearchAssetsErrorType = EmptyError & HubspotMetadata;
export const searchAssetsRpc: ChirpAvroRpcDetails<
  SearchAssetsRequestType,
  SearchAssetsResponseType,
  SearchAssetsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.personalization.rpc.PersonalizationPublicRpc',
  rpcName: 'searchAssets',
  auth: 'external',
  fingerprint: 'genRUNkvVs6kD5Z6FkgKIJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
